import { render } from "./WhyChoose.vue?vue&type=template&id=7ad4f338"
import script from "./WhyChoose.vue?vue&type=script&lang=js"
export * from "./WhyChoose.vue?vue&type=script&lang=js"
script.render = render

export default script